module.exports = __webpack_public_path__ + "media/images/search-modal-header@2x-a1c64188749c75caef81565488d894a1.png";